import { Form } from 'react-bootstrap';
import * as api from '../api';
import {PROJECT_ACTION} from '../interface';
//Action Creators


//@ts-ignore
export const getProject = (id) => async (dispatch) => {
    try { 
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        const {data: { project}} = await api.fetchProject(id);
        // console.log(data);
        await dispatch({ type: PROJECT_ACTION.FETCH_PROJECT, payload:{ project } });
        await dispatch({type:PROJECT_ACTION.END_LOADING});

    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const createProject = (newProject)=> async(dispatch)=>{
    try { 
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        
        await api.createProject(newProject);
        await dispatch({type:PROJECT_ACTION.END_LOADING});

        // const {data:{project}} = await api.createProject(newProject);
        // dispatch({ type: PROJECT_ACTION.CREATE, payload:{project} });
    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const getProjects = (page) => async (dispatch) => {
    try { 
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        const {data: { projects, currentPage, numberOfPages }} = await api.fetchProjects(page);
        console.log(numberOfPages);
        await dispatch({ type: PROJECT_ACTION.FETCH_ALL, payload:{ projects, currentPage, numberOfPages } });
        await dispatch({type:PROJECT_ACTION.END_LOADING});

    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const getProjectsBySearch = (searchQuery, page) => async (dispatch) => {
    try { 
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        console.log(searchQuery);
        const {data:{projects, currentPage, numberOfPages}} = await api.fetchProjectsBySearch(searchQuery, page);
        console.log(projects);
        console.log(numberOfPages);

        await dispatch({ type: PROJECT_ACTION.FETCH_BY_SEARCH, payload:{projects, currentPage, numberOfPages} });
        await dispatch({type:PROJECT_ACTION.END_LOADING});

    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const updateProject = (id,newProject)=> async(dispatch)=>{
    try { 
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        await api.updateProject(id,newProject);
        await dispatch({type:PROJECT_ACTION.END_LOADING});

        // const {data:{project}} = await api.updateProject(id,newProject);
        // dispatch({ type: PROJECT_ACTION.UPDATE, payload:{project} });
    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const likeProject = (id)=> async(dispatch)=>{
    try { 
        const {data:{project}} = await api.likeProject(id);

        dispatch({ type: PROJECT_ACTION.LIKE, payload:{project} });
    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const deleteProject = (id)=> async(dispatch)=>{
    try { 
        // dispatch({type:PROJECT_ACTION.START_LOADING});
        await api.deleteProject(id);
        // dispatch({type:PROJECT_ACTION.END_LOADING});


        await dispatch({ type: PROJECT_ACTION.DELETE, payload:{id} });
    } catch(error) {
        console.log(error);
     }
}

//@ts-ignore
export const colabProject = (id, colabForm)=> async(dispatch)=>{
    try { 
        console.log("colab start loading dispatching");
        await dispatch({type:PROJECT_ACTION.START_LOADING});
        console.log("colab start loading dispatched");
        const {data:{project}} = await api.colabProject(id, colabForm);
        console.log("api complete");
        console.log("colab colab loading dispatching");
        dispatch({ type: PROJECT_ACTION.COLAB, payload:{project} });
        console.log("colab colab loading dispatched");
        await dispatch({type:PROJECT_ACTION.END_LOADING});
        console.log("colab end loading dispatched");

    } catch(error) {
        console.log(error);
     }
}


